import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CommonService, UserService } from '../services';

@Injectable()
export class RedirectToGuard implements CanActivate {

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private commonService: CommonService,
        private userService: UserService
    ) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let path = state.url.split('?', 1)[0];
        if ( path.charAt( 0 ) === '/' ) {
            path = path.slice( 1 );
        }
        const queryParams = next.queryParams;
        // Check for user already have company selected and got query params to auto select company
        if (queryParams['company_id'] && this.userService.getCompany().id
            && queryParams['company_id'] !== this.userService.getCompany().id) {
            this.userService.deleteCompany();
        }
        this.commonService.setRedirectTo(path, queryParams);
        return true;
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/guards/redirect-to.guard.ts